import { useState } from "react";
import { Box, Typography } from "@mui/material";
import AutoAwesomeOutlinedIcon from "@mui/icons-material/AutoAwesomeOutlined";

import styles from "../../../../assets/styles/componentStyles/billingStyles/billingUsage.module.scss";

import BuyAiCreditsPopup from "../../popup/buyAiCreditsPopup";
import GlobalButton from "../../../utility/globalButton/button";

const PurchaseCredits = () => {

    const [openBuyCredits, setOpenBuyCredits] = useState(false);

    return (
        <>
            <Box className={styles.purchaseCreditsCard}>

                <Box className={styles.purchaseCreditsLeft}>
                    <Box className={styles.purchaseCreditsIcon}>
                        <AutoAwesomeOutlinedIcon />
                    </Box>

                    <Box className={styles.purchaseCreditsText}>
                        <Typography className={styles.purchaseCreditsTitle}>
                            Need more AI credits?
                        </Typography>
                        <Typography className={styles.purchaseCreditsDescription}>
                            Purchase additional credits anytime.
                        </Typography>
                    </Box>
                </Box>

                <GlobalButton
                    className="borderedButtonStyle"
                    onClick={() => setOpenBuyCredits(true)}
                    buttonText="Add Credits"
                />

            </Box>

            <BuyAiCreditsPopup
                open={openBuyCredits}
                onClose={() => setOpenBuyCredits(false)}
            />
        </>
    );
};

export default PurchaseCredits;
